import React from 'react';

import { CRAScreen } from './CRAScreen';

/**
 * CRAPage - Wrapper component for Context Review and Analysis screen
 * Provides routing and state management for the CRA functionality
 */
export const CRAPage: React.FC = () => {
  return <CRAScreen />;
};
